import TableToolbarRoot from './components/toolbar-root.jsx'
import ToolbarSearch from './components/toolbar-search.jsx'
import ToolbarFilter from './components/toolbar-filter.jsx'
import ToolbarRightContainer from './components/toolbar-right-container.jsx'
import ToolbarLeftContainer from './components/toolbar-left-container.jsx'
import ToolbarPageSize from './components/toolbar-page-size.jsx'

const TableToolbar = {
  Root: TableToolbarRoot,
  Filter: ToolbarFilter,
  Search: ToolbarSearch,
  RightContainer: ToolbarRightContainer,
  LeftContainer: ToolbarLeftContainer,
  PageSize: ToolbarPageSize
}

export default TableToolbar
